export default "__VITE_ASSET__DFjMj6DW__"